const MAX_ERRORS = 20;
const MAX_CHARS = 240;

const recent: string[] = [];

export function noteClientError(message: string): void {
  const line = message.replace(/\s+/g, ' ').trim().slice(0, MAX_CHARS);
  if (!line) return;
  recent.push(line);
  if (recent.length > MAX_ERRORS) recent.splice(0, recent.length - MAX_ERRORS);
}

export function recentClientErrors(): string[] {
  return recent.slice();
}

export function installClientErrorLog(): void {
  const original = console.error.bind(console);
  console.error = (...args: unknown[]) => {
    noteClientError(args.map((part) => (part instanceof Error ? part.message : String(part))).join(' '));
    original(...args);
  };
  window.addEventListener('error', (event) => {
    noteClientError(event.message || 'error');
  });
  window.addEventListener('unhandledrejection', (event) => {
    const reason = event.reason;
    noteClientError(reason instanceof Error ? reason.message : String(reason));
  });
}
